import React from 'react';
import styled from 'styled-components';

import BreadCrumb from '@/components/BreadCrumb';
import { BreadCrumbType } from '@/typings/common';

type Props = {
  breadCrumbs: BreadCrumbType[];
};

function PageHeader({ breadCrumbs }: Props) {
  return (
    <Component>
      <BreadCrumb breadCrumbs={breadCrumbs} />
    </Component>
  );
}

export default PageHeader;

const Component = styled.div``;
